module.exports = __webpack_public_path__ + "Sailec-Regular.1501a344f084fda78635.eot";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/Sailec-Regular/Sailec-Regular.eot
// module id = ../../../../../src/assets/fonts/Sailec-Regular/Sailec-Regular.eot
// module chunks = styles